import * as apis from 'libs/apis/helper'
import i18n from 'config/i18n'
import { forceSessionCleanup } from 'helpers/forceSessionCleanup'

import type { IUserInfoProps, IUserForm, AuthSuccess } from './model'

export const login = async (params: IUserForm): Promise<AuthSuccess> => {
  const response = await apis.fetchAPI({
    method: 'POST',
    path: '/v1/auth',
    options: { data: params },
  })

  if (response.status !== 200) {
    throw new Error(i18n.t('error:notFound.title'))
  }

  return response.body as AuthSuccess
}

export { clearLogoutLocalState } from 'helpers/clearLogoutLocalState'

export const logout = async (): Promise<void> => {
  try {
    await apis.fetchAPI({
      method: 'POST',
      path: '/v1/auth/logout',
    })
  } finally {
    forceSessionCleanup()
  }
}

export const getUserInfo = async (): Promise<IUserInfoProps> => {
  const user = await apis.fetchAPI({
    method: 'GET',
    path: '/v1/auth',
  })

  if (user.status !== 200) {
    throw new Error(i18n.t('error:notFound.title'))
  }

  return user.body as IUserInfoProps
}
